export * from './legacy-sidebar.component';
